import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from "@material-ui/core";
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import ColorPickerPopover from "../../../../../../../../../Utils/ColorPickerPopover";

const ColorPicker = ({label, path, setValue, values, withGradient, width, labelStyles = {}, disabled}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    function onClick(e) {
        if(disabled) return;
        setAnchorEl(e.currentTarget)
    }

    function completeColor(color, name, path) {
        setValue(color, path)
    }

    const currentColor = findByString(values, path);
    return (
        <div style={{display: 'flex', margin: '5px 0 10px 0'}}>
            {label && (
                <div style={{width: 105, ...labelStyles}}>
                    {label}
                </div>
            )}
            <div style={{
                width: width ? width : 40,
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            }}
                 onClick={onClick}
            >
                <Tooltip title={"Select Color"}>
                    <div style={{
                        borderRadius: '2px',
                        height: '14px',
                        background: currentColor || 'rgba(0,0,0,1)'
                    }}/>
                </Tooltip>
            </div>
            <ColorPickerPopover
                open={Boolean(anchorEl)}
                path={path}
                color={currentColor}
                close={() => setAnchorEl(null)}
                complete={completeColor}
                anchorEl={anchorEl}
                type={"sketch"}
                disabled={disabled}
                withGradient={withGradient}
            />
        </div>
    )
};

ColorPicker.propTypes = {
    label: PropTypes.string,
    path: PropTypes.string,
    setValue: PropTypes.func,
    values: PropTypes.object
};

export default ColorPicker;